import { getTokenValue } from '@atlaskit/tokens';
import { rgb } from 'd3-color';
function getLuminance(_ref) {
  let {
    r,
    g,
    b
  } = _ref;
  const a = [r, g, b].map(v => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function getContrast(color1, color2) {
  const lum1 = getLuminance(color1) + 0.05;
  const lum2 = getLuminance(color2) + 0.05;
  return Math.max(lum1, lum2) / Math.min(lum1, lum2);
}
function getTokenAndFallback(cssVar) {
  // Extract the number from the CSS variable name
  const numberMatch = cssVar.match(/\d+/);
  const number = numberMatch ? numberMatch[0] : '';
  // Extract all terms following '--ds-' and before the number
  const termsMatch = cssVar.match(/--ds-(.+)-\d+/);
  const terms = termsMatch ? termsMatch[1].split('-') : [];
  // Extract the hexadecimal color from the CSS variable
  const hexColorMatch = cssVar.match(/#[0-9a-fA-F]{6}/);
  const hexColor = hexColorMatch ? hexColorMatch[0] : '';
  // Create the desired format by joining all extracted terms
  const token = `color.${terms.join('.') + '.' + number}`;
  return {
    token,
    fallback: hexColor
  };
}
export function getMaxContrast(arcColor) {
  const isPattern = arcColor.includes('url');
  const {
    token,
    fallback
  } = getTokenAndFallback(arcColor);
  const colorHex = getTokenValue(token, fallback);
  const color = rgb(arcColor.startsWith('var(') ? colorHex : arcColor);
  if (isPattern) return 'black';
  if (!color) return '';
  const blackContrast = getContrast(color, rgb('black'));
  const whiteContrast = getContrast(color, rgb('white'));
  if (whiteContrast >= 4.5) {
    return 'white';
  }
  if (blackContrast >= 4.5) {
    return 'black';
  }
  return 'white';
}